import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/schemas';
import { AiRolePlaySubmission } from 'redux/schemas/models/ai-role-play';
import { User } from 'redux/schemas/models/my-account';
import { getCurrentUser } from 'redux/selectors/users';
import AiConversationContext from './context';

type UseViewedSubmissionResult = {
  viewedSubmission: AiRolePlaySubmission | null;
  isCurrentUserSubmission: boolean;
  profile: User;
};

const useViewedSubmission = (): UseViewedSubmissionResult => {
  const { sessionData } = useContext(AiConversationContext);
  const currentUser = useSelector(getCurrentUser);
  const viewedSubmission = useSelector((state: RootState) => (
    sessionData?.submissionId
      ? state.models.aiRolePlaySubmissions[sessionData.submissionId] ?? null
      : null
  ));
  const submissionUserId = viewedSubmission?.user?.id;
  const currentUserId = currentUser?.id;
  const isCurrentUserSubmission = !submissionUserId || (
    !!(submissionUserId && currentUserId && submissionUserId === currentUserId)
  );
  const profile = viewedSubmission?.user ?? currentUser ?? {};

  return { viewedSubmission, isCurrentUserSubmission, profile };
};

export default useViewedSubmission;
